function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.112 30V16.315h4.593l.688-5.333h-5.281v-3.4c0-1.544.429-2.6 2.643-2.6h2.824V.212a37.85 37.85 0 00-4.115-.21c-4.072 0-6.859 2.485-6.859 7.049v3.933H0v5.333h4.605V30z",
  fill: "#213854"
});

var SvgFacebookIcon = function SvgFacebookIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 15.58 30"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNS41OCAzMCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6IzIxMzg1NDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImEiIGQ9Ik05OC41NCw0Mi44MjlWMjkuMTQ0aDQuNTkzbC42ODgtNS4zMzNIOTguNTR2LTMuNGMwLTEuNTQ0LjQyOS0yLjYsMi42NDMtMi42aDIuODI0di00Ljc3YTM3Ljg1LDM3Ljg1LDAsMCwwLTQuMTE1LS4yMWMtNC4wNzIsMC02Ljg1OSwyLjQ4NS02Ljg1OSw3LjA0OXYzLjkzM0g4OC40Mjh2NS4zMzNoNC42MDVWNDIuODI5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg4LjQyOCAtMTIuODI5KSIvPjwvc3ZnPg==";
export { SvgFacebookIcon as ReactComponent };